export default __webpack_public_path__ + "static/background-image-708128dcd37203f640b4f32f803f626f.jpg";